$(document).ready(function () {
    $('.image-owlcarousel .wrappers .items').owlCarousel({
        center: true,
        items:1,
        loop:true,
        dots: true,
        nav: false,
        margin:30,
        autoplay:true,
        autoplayTimeout:3000,
        responsive:{
            0:{
                items:1,
                center: false,
                margin:0
            },
            568:{
                items:2
            }
        }
    });
});